<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="true" type="primary" size="mini" @click="handleAdd") 新增 
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row.py-3(type="flex" justify="center")
        el-col(:span="13")
          el-row(type="flex" justify="center" :gutter="10")
            el-col(:span="13")
              el-input.w-100(v-model="list.name" placeholder="请输入供应商名称" clearable)
            el-col(:span="11")
              el-button(type="primary" @click="search" :loading="loading") 查询
      el-table(:data="data" v-loading="loading" size="mini")
        el-table-column(prop="name" label="标题名称")
        el-table-column(prop="supplier_name" label="供应商名称")
        el-table-column(prop="latest_price1" label="钢坯基准价" width="100")
        el-table-column(prop="registrant" label="注册人姓名" width="90")
        el-table-column(prop="registrant_phone" label="联系方式"  width="110")
        el-table-column(prop="supplier_level" label="供应商等级" width="80")
        el-table-column(prop="create_time" label="提交时间" width="100")
        el-table-column(prop="last_time" label="最近调价时间" width="160")
        el-table-column(prop="last_state_name" label="最近调价状态" width="160")
        el-table-column(label="操作" width="300")
          template(slot-scope="scope")
            el-button(size="mini" type="primary" plain @click="goto('/admin/price_data_edit/'+scope.row.id)") 编辑
            el-button(size="mini" type="primary" plain @click="handleEdit(scope.row)") 调价
            el-button(size="mini" type="primary" plain @click="goto('/admin/price_data_detail/'+scope.row.id)") 查看
            el-button(size="mini" type="primary" plain @click="handleDelete(scope.$index, scope.row)") 删除      
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total, sizes, prev, pager, next, jumper" :total="count" background)
    el-dialog.dialog(:title="title" :visible.sync="dialogFormVisible" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
      el-form(:model="form1" ref="form1" size="mini" label-width="90px" :rules="rules")
        el-form-item(label="标题" prop="name")
          el-input(v-model="form1.name")
        el-form-item(label="供应商" prop="pk_supplier")
          el-select.w-100(v-model="form1.pk_supplier" filterable remote placeholder="请搜索供应商" :disabled="disabled" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
            el-option(v-for="item in supply" :key="item.code" :label="item.name" :value="item.code") 
        el-form-item(label="钢坯基准价" prop="latest_price1")
          el-input-number.w-100(v-model="form1.latest_price1" controls-position="right" :min="0" :precision="2" )   
      div(slot="footer" class="dialog-footer")
        el-button(size="mini" @click="dialogFormVisible = false") 取 消
        el-button(size="mini" type="primary" :loading="loading" @click="submitForm") 确 定 
    el-dialog.dialog(:title="title" :visible.sync="dialogFormVisibleEdit" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
      el-form(:model="form2" ref="form2" size="mini" label-width="90px" :rules="rules")
        el-form-item(label="调价金额" prop="money")
          el-input-number.w-100(v-model="form2.money" controls-position="right" :precision="2")  
        el-form-item(label="调价原因" prop="reason")
          el-input(v-model="form2.reason" type="textarea" :autosize="{ minRows: 2, maxRows: 4}")  
      div(slot="footer" class="dialog-footer")
        el-button(size="mini" @click="dialogFormVisibleEdit = false") 取 消
        el-button(size="mini" type="primary" :loading="loading" @click="submitFormEdit") 确 定   

</template>
<script>
export default {
  data() {
    return {
      h: "",
      title: "新增",
      loading: false,
      data: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      count: 0,
      list: {
        name: "",
        page_num: 1,
        page_size: 10,
      },
      loadingSupply: false,
      form1: {
        name: "",
        pk_supplier: "",
        latest_price1: 0,
      },
      form2: {
        id: "",
        money: 0,
        reason: "",
      },
      supply: [],
      disabled: false,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        pk_supplier: [
          { required: true, message: "请选择供应商", trigger: "blur" },
        ],
        money: [{ required: true, message: "请输入调价金额", trigger: "blur" }],
        reason: [
          {
            required: true,
            message: "请输入调价原因",
            trigger: "blur",
          },
        ],
      },
      e: {},
    };
  },
  methods: {
    goto(path) {
      localStorage.setItem("PriceData_page_num", this.list.page_num);
      this.$router.push(path);
    },
    search() {
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.title = "新增";
      this.form1 = {
        name: "",
        pk_supplier: "",
        latest_price1: 0,
      };
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.pricedata.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count = res.count;
      }
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await this.$api.pricedata.del(row.id);
          this.loading = false;
          if (res) {
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        })
        .catch(() => {});
    },
    init() {
      let data = this.$route.query;
      if (data) {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
      }
      this.getList();
    },
    submitForm() {
      this.$refs["form1"].validate(async (valid) => {
        if (valid) {
          let res = null;
          this.loading = true;
          if (this.title == "新增") {
            res = await this.$api.pricedata.add(this.form1);
          } else {
            res = await this.$api.pricedata.edit(this.form1);
          }
          this.loading = false;
          if (res) {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    handleEdit(e) {
      this.dialogFormVisibleEdit = true;
      this.title = "调价";
      this.e = e;
      this.$nextTick(() => {
        this.form2.money = 0;
        this.form2.reason = "";
      });
    },
    submitFormEdit() {
      this.$refs["form2"].validate(async (valid) => {
        if (valid) {
          let data = {
            pk_guide: this.e.id,
            money: this.form2.money,
            reason: this.form2.reason,
          };
          this.loading = true;
          let res = await this.$api.pricedata.edit(data);
          this.loading = false;
          if (res) {
            this.dialogFormVisibleEdit = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>